export default "__VITE_ASSET__D249eoAa__"